export default __webpack_public_path__ + "static/media/BrainBreak cards85.d7b24010.png";